import { useContext } from "react";

import { UserContext } from "@hooks/useUserContext/UserContext";

export const useUserContext = () => useContext(UserContext);
